/*
 * Funnel events for Microsoft Clarity. Clarity's own "Add to cart" / "Checkout" smart events are
 * guessed from button text and do not understand the cake configurator, so these are ours.
 * Clarity funnel (Settings → Funnels): /products/ → bh_configurator_open → bh_date_picked →
 * bh_add_to_cart → bh_phone_entered → bh_checkout_click.
 *
 * window.bhClarityEvent(name): once per page, queued until Clarity exists, never throws.
 * Most steps are heard here from events the theme already fires, so components stay untouched:
 *  - bh_configurator_open: first REAL tap/typing inside #BakehuntersForm (isTrusted, so restoring
 *    a cart edit on load does not count).
 *  - bh_date_picked: bh-date-picker writes the date into #DeliveryDate and fires `change`.
 *  - bh_add_to_cart: the configurator fires `cart:item-added` with NO detail; the cart upsells
 *    (candles, certificate) fire it WITH detail.product, so they are skipped.
 *  - bh_checkout_click: any [name="checkout"] (cart page + sticky bar; the drawer has none).
 *  - bh_phone_entered: called from bh-phone-field.js, at the same moment as the QuickOrder beacon.
 */
(function () {
  var sent = {};
  var queue = [];
  var tries = 0;

  function flush() {
    if (window.clarity) {
      queue.splice(0).forEach(function (n) { try { window.clarity('event', n); } catch (e) {} });
    } else if (queue.length && tries++ < 40) {
      setTimeout(flush, 500); // ponytail: polls up to 20s for the deferred app embed
    }
  }

  window.bhClarityEvent = function (name) {
    if (sent[name]) return;
    sent[name] = true;
    queue.push(name);
    flush();
  };

  function inForm(e) { return e.isTrusted && e.target.closest && e.target.closest('#BakehuntersForm'); }
  document.addEventListener('click', function (e) {
    if (inForm(e)) window.bhClarityEvent('bh_configurator_open');
    if (e.target.closest && e.target.closest('[name="checkout"]')) window.bhClarityEvent('bh_checkout_click');
  }, true);
  document.addEventListener('input', function (e) {
    if (inForm(e)) window.bhClarityEvent('bh_configurator_open');
  }, true);
  // Bubble phase, not capture: the configurator's own listener on #DeliveryDate runs first and
  // clears a date it rejects (same-day past cutoff), so a rejected date is not counted.
  document.addEventListener('change', function (e) {
    if (e.target.id === 'DeliveryDate' && e.target.value) window.bhClarityEvent('bh_date_picked');
  });
  document.documentElement.addEventListener('cart:item-added', function (e) {
    if (!e.detail) window.bhClarityEvent('bh_add_to_cart');
  });
})();
